import { useState, useEffect } from 'react';
import api from '../utils/api';

let cache = null;
let inflight = null;

/** Clear cached countries (e.g. after re-seeding `countries`). */
export function invalidateCountriesCache() {
  cache = null;
  inflight = null;
}

/**
 * Countries from seeded `countries` table via GET /utils/countries.
 * Options shaped as { code, label, isoCode, name } for Autocomplete compatibility.
 */
export default function useCountries() {
  const [items, setItems] = useState(cache);
  const [loading, setLoading] = useState(cache == null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (cache) {
      setItems(cache);
      setLoading(false);
      return;
    }
    if (!inflight) {
      inflight = api
        .get('/utils/countries')
        .then((r) => {
          const list = Array.isArray(r.data?.data) ? r.data.data : [];
          cache = list;
          return list;
        })
        .catch((e) => {
          setError(e);
          return [];
        })
        .finally(() => {
          inflight = null;
        });
    }
    inflight.then((list) => {
      setItems(list);
      setLoading(false);
    });
  }, []);

  return { countries: items || [], loading, error };
}

export function labelForCountry(code, countries) {
  if (!code || !Array.isArray(countries)) return code || '';
  const want = String(code).toUpperCase();
  const row = countries.find((c) => String(c.code || c.isoCode || '').toUpperCase() === want);
  return row?.label || row?.name || String(code);
}
